<template>
  <div class="blex frame">
    <!-- framae image   -->
    <img src="@/assets/images/pages/main/map/frame4.svg" class="hidden lg:block desc">
    <img src="@/assets/images/pages/main/map/mFrame3.svg" class="block lg:hidden">

    <div class="detail">

      <!-- 세계관 이름     -->
      <div class="text-white font-semiBold pb-8 lg:pb-0 text-xl lg:text-4xl">
        {{ $t(value.name) }}
      </div>
      <vs-divider color="white" class="hidden lg:block"></vs-divider>
      <!-- 세계관 설명     -->
      <div class="text-white font-normal text-3xs lg:text-base leading-2xs lg:leading-xs text-center">
        {{ $t(value.desc) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Description',
  props: {
    value: {
      type: Object
    }
  },
  watch: {
    value: {
      deep: true, // default : false
      immediate: true,
      handler (val) {
        this.value = val
      }
    }
  }
}
</script>

<style scoped lang="scss">
div::v-deep {
  z-index: 10;

  .detail {
    position: absolute;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 500px;
    padding: 40px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    @media screen and (max-width: 1024px) {
      width: 328px;
      padding: 16px;

    }
  }

}

</style>